import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isMainDrawerOpen, setIsMainDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsMainDrawerOpen(prev => !prev);
  };

  return (
    <SidebarContext.Provider value={{
      isMainDrawerOpen,
      setIsMainDrawerOpen,
      toggleDrawer
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
